import { createContext } from 'react'

/** For more details on
 * `appStateContext`, `ProvideAppState`, `useAppState` and `useProvideAppState`
 * refer to: https://usehooks.com/useAuth/
 */
export const appStateContext = createContext()
